import releasesImg from './home/releases.jpg';
import newsletterImg from './home/newsletter.jpg';
import alertImg from './home/alert.jpg';
import audiosImg from './media/audios.jpg';
import videosImg from './media/videos.jpg';
import galleryImg from './media/gallery.jpg';
import politicasImg from './standards/politicas.jpg';
import criticosImg from './standards/criticos.jpg';
import reglasImg from './standards/reglas.jpg';
import tarImg from './standards/tar.jpg';
import otrosImg from './standards/otros.jpg';
import blastingImg from './reports/blasting.jpg';
import meetingImg from './reports/meeting.jpg';
import brigadesImg from './reports/brigades.jpg';
import safetyImg from './reports/safety.jpg';
import incidentsImg from './reports/incidents.jpg';
import maintenanceImg from './reports/maintenance.jpg';
import textureImg from './backgrounds/texture.jpg';

const BY_CATEGORY: Record<string, string> = {
  publicacion: newsletterImg,
  alerta: alertImg,
  blasting: blastingImg,
  meeting: meetingImg,
  brigades: brigadesImg,
  safety: safetyImg,
  incidents: incidentsImg,
  maintenance: maintenanceImg,
  critical: criticosImg,
  'life-saving': reglasImg,
  tar: tarImg,
  other: otrosImg,
};

const BY_COLLECTION: Record<string, string> = {
  releases: releasesImg,
  newsletters: newsletterImg,
  podcasts: audiosImg,
  videos: videosImg,
  galleries: galleryImg,
  policies: politicasImg,
  critical_standars: criticosImg,
  reports: blastingImg,
};

export function getDefaultImage(collection: string, category?: string): string {
  if (category && BY_CATEGORY[category]) return BY_CATEGORY[category];
  return BY_COLLECTION[collection] ?? textureImg;
}
